import { Injectable } from '@angular/core';
import { BaseStoreFacade } from '@city/data-access';
import { select, Store } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable } from 'rxjs';
import { MainActions } from './store/actions';
import { MAIN_PHONE_FEATURE, MainPhoneMenu, MainPhoneState } from './store/main-phone-state';
import { MainSelectors } from './store/selectors';

@Injectable({
  providedIn: 'root',
})
export class MainStatePersistenceService {
  constructor(
    protected statePersistenceService: StatePersistenceService,
    protected store: Store<MainPhoneMenu>,
    private baseStores: BaseStoreFacade,
  ) {}

  public sync(): void {
    this.statePersistenceService.syncWithStorage({
      key: MAIN_PHONE_FEATURE,
      state$: this.getState(),
      context$: this.baseStores.getActiveCode(),
      storageType: StorageSyncType.SESSION_STORAGE,
      onRead: (state: MainPhoneState) => this.onRead(state),
    });
  }

  protected getState(): Observable<MainPhoneState> {
    return this.store.pipe(select(MainSelectors.getFeatureState));
  }

  protected onRead(state?: Partial<MainPhoneState>): void {
    if (state?.phone?.value) {
      this.store.dispatch(new MainActions.PhoneLoadSuccess(state.phone.value));
    }
  }
}
